module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKWyV9hmIqOjjg.a3c37f7f.woff2";